























































































































import {
  Component,
  Prop,
  Vue,
  Model,
} from 'vue-property-decorator';

@Component
export default class SearchResult extends Vue {
  @Prop() private msg!: string;

  @Model() readonly searchResult!: Array<any>;
}
